"use strict";

exports.__esModule = true;
var _Text = require("./Text");
Object.keys(_Text).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Text[key]) return;
  exports[key] = _Text[key];
});
var _LeadText = require("./LeadText");
Object.keys(_LeadText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LeadText[key]) return;
  exports[key] = _LeadText[key];
});